import axiosInstance from "./AxiosInstance";

export default {
    get() {
        return axiosInstance({
            method: "get",
            url: "/users",
        });
    },
    getByLdap(ldap_login) {
        return axiosInstance({
            method: "post",
            url: "/users/by_login",
            data: {
                ldap_login,
            },
        });
    },
    create(body) {
        return axiosInstance({
            method: "post",
            url: "/users",
            data: body,
        });
    },
    update(id, body) {
        return axiosInstance({
            method: "patch",
            url: `/users/${id}`,
            data: body,
        });
    },
    delete(id) {
        return axiosInstance({
            method: "delete",
            url: `/users/${id}`,
        });
    },
};
